import { useParams } from 'react-router-dom'

import { useAiTagGetApi } from '@/common/api/modules/aiTag'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import TagEditPage from '@/components/container/page/site/recommend/TagEditPage'

const TagUpdatePage = () => {
  const { siteId, tagId } = useParams()

  const { data, error, mutate } = useAiTagGetApi({
    site_id: Number(siteId),
    tag_id: Number(tagId)
  })

  return (
    <DetailPageLoader error={error} data={data} small>
      <TagEditPage tag={data} onRefetch={mutate} />
    </DetailPageLoader>
  )
}

export default TagUpdatePage
